var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-counterparty-form',{attrs:{"next-step-path":"PartnerPortal-ReportDamage-ThankYou","previous-step-path":"PartnerPortal-ReportDamage-Deadline","is-broker":true,"create-claim-action":"createBrokerLegalClaim"}})}
var staticRenderFns = []

export { render, staticRenderFns }